export * from "./memory-detail-access-modal";